import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';

// Components
import { AppComponent } from './app.component';
import { AuthComponent } from './auth/auth.component';
import { LandingComponent } from './landing/landing.component';

// Modules
import { AppRoutingModule } from './app-routing.module';
import { HomeModule } from './home/home.module';

// Services
import * as CoreServices from './core/services/index';
import { AuthService } from './auth/auth.service';

// Styles
import { CoreModule } from './core/core.module';
import { HttpClient } from '@angular/common/http';
import { APP_INITIALIZER } from '@angular/core';
import { EnvironmentService } from './core/services/environment.service';
import { StorageService } from './core/services/storage.service';
import { HttpClientModule } from '@angular/common/http';
import { PreloaderService } from './core/components/preloader/preloader.service';
import { Http } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { HttpService } from './core/services/http.service';
import { AuthorizationComponent } from './authorization/authorization.component';
import { AuthorizationGuard } from './core/guard/authorization.guard';
import { AuthenticationGuard } from './core/guard/authentication.guard';
import { AuthorizationService } from './core/services/authorization.service';
import { UserService } from './core/services/user.service';
import { UserGuard } from './core/guard/user.guard';
import { ApiListService } from './home/discover-api/api-list/api-list.service';
import { IdentityService } from './identity.service';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    // Components
    AppComponent,
    AuthComponent,
    LandingComponent,
    AuthorizationComponent,
    // Directives

    // Pipes
  ],
  imports: [
    HttpModule,
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    RouterModule,
    NgbModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
  }),
    ToastrModule.forRoot(),
    CoreModule,
    AppRoutingModule
  ],
  providers: [
    EnvironmentService,
    HttpClient,
    AuthService,
    AuthorizationService,
    UserService,
    PreloaderService,
    AuthenticationGuard,
    UserGuard,
    AuthorizationGuard,
    ApiListService,
    HttpService,
    IdentityService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/app.module.ts